import { atom } from 'recoil';

export const activeIndexAtom = atom({
  key: 'features/activeIndex',
  default: -1,
});
